"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewAndEditCarDetailsWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var moment = require("moment");
var journey_services_1 = require("@athena-portal/journey-services");
var commonFunctions_1 = require("../../../commonFunctions");
var LookupWidgetBase_1 = require("../../LookupWidgetBase");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var PricingExplainedInfo_1 = require("../../../components/PricingExplainedInfo");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var components_1 = require("@athena-portal/components");
var ViewAndEditCarDetailsWidget = /** @class */ (function (_super) {
    __extends(ViewAndEditCarDetailsWidget, _super);
    function ViewAndEditCarDetailsWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vehicleIndex = (0, commonFunctions_1.getIndexSetting)("vehicleIndex", _this.getSetting("vehicleIndex", undefined), _this.props.question.type);
        _this.startDateExpression = _this.getSetting("startDateExpression", undefined);
        if (!_this.startDateExpression) {
            throw Error("".concat(_this.props.question.type, " widget missing 'startDateExpression' setting"));
        }
        _this.state = __assign({}, _this.state);
        _this.renderCars = _this.renderCars.bind(_this);
        return _this;
    }
    ViewAndEditCarDetailsWidget.prototype.render = function () {
        if (this.state.policies && this.state.subscription) {
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: this.renderCars() }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    ViewAndEditCarDetailsWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.fetchLookupValues("vehicleTransmission");
        this.fetchLookupValues("vehicleFuelType");
        this.fetchLookupValues("vehicleTransmission");
        this.customerPortalService.getSubscription().subscribe(function (subscription) {
            if (subscription) {
                _this.setState({ subscription: subscription });
            }
        });
        this.customerPortalService.getPolicies().subscribe(function (policies) {
            if (policies) {
                _this.setState({ policies: policies });
            }
        });
    };
    ViewAndEditCarDetailsWidget.prototype.renderCars = function () {
        var coverStartDate = journey_services_1.ExpressionEvaluator.evaluateExpression(this.startDateExpression, this.props.interaction, undefined);
        var nextPaymentDate = this.props.interaction.vehicles[0].factors.constraintEndDate ?
            moment(this.props.interaction.vehicles[0].factors.constraintEndDate) :
            moment(this.props.interaction.headerInfo.startDate).add(3, "M").subtract(1, 'd');
        if (this.props.interaction.vehicles) {
            var vehicle = this.props.interaction.vehicles[this.vehicleIndex];
            return ((0, jsx_runtime_1.jsxs)("div", { className: "widget carExcess-widget", children: [(0, jsx_runtime_1.jsxs)("div", { className: "panel-detail-output-entity", children: [(0, jsx_runtime_1.jsx)("img", { className: "vehicle-icon", alt: "Vehicle icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-car-icon.png") }), (0, jsx_runtime_1.jsxs)("h2", { className: "center dashboard-panel-title m-0", children: [vehicle.make, ", ", vehicle.model] }), (0, jsx_runtime_1.jsxs)("p", { className: "center mb-3", children: [vehicle.year, ", ", this.resolveLookupValue("vehicleTransmission", vehicle.transmission), ", ", this.resolveLookupValue("vehicleFuelType", (0, commonFunctions_1.getInteractionVehicleFuelType)(vehicle.fuelType, vehicle.fuelTypeFull))] }), (0, jsx_runtime_1.jsx)("div", { className: "number-plate-preview", children: vehicle.registrationNumber })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("p", { className: "price-never-higher", children: [(0, commonFunctions_1.getAmountToDisplay)((0, commonFunctions_1.getNeverHigherPeriodAmount)(this.props.interaction)), (0, jsx_runtime_1.jsx)("span", { className: "font-weight-light fs-20", children: " or lower" })] }), (0, jsx_runtime_1.jsxs)("p", { className: "text-center", children: ["per month until ".concat(nextPaymentDate.format("Do MMMM YYYY")), (0, jsx_runtime_1.jsx)(InfoModal_1.InfoModal, { title: "Pricing explained", className: "pl-3", children: (0, jsx_runtime_1.jsx)(PricingExplainedInfo_1.PricingExplainedInfo, { interaction: this.props.interaction, subscription: this.state.subscription, policies: this.state.policies }) })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "panel-detail-output-entity", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("label", { className: "muli-bold-16", children: "Start date" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("p", { children: (0, commonFunctions_1.convertDate)(coverStartDate, "Do MMMM YYYY") }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "panel-detail-output-entity", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("label", { className: "muli-bold-16", children: "Cover type" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("p", { children: "Comprehensive" }) })] }), (0, jsx_runtime_1.jsx)("div", { className: "panel-detail-output-entity", children: (0, jsx_runtime_1.jsxs)("div", { className: "bottom-border-margin", children: [(0, jsx_runtime_1.jsx)("div", { className: "muli-bold-16 cover-type-label", children: "Use" }), (0, jsx_runtime_1.jsx)("div", { className: "cover-type-content", children: vehicle.businessUse ? "Business use excluding commercial travelling" :
                                        "Social domestic and pleasure including commuting to one place to work" })] }) })] }));
        }
        else {
            return null;
        }
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], ViewAndEditCarDetailsWidget.prototype, "customerPortalService", void 0);
    return ViewAndEditCarDetailsWidget;
}(LookupWidgetBase_1.LookupWidgetBase));
exports.ViewAndEditCarDetailsWidget = ViewAndEditCarDetailsWidget;
//# sourceMappingURL=ViewAndEditCarDetailsWidget.js.map